var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8015_1966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1646 8.33198C18.5451 10.1994 18.2739 12.1409 17.3963 13.8326C16.5186 15.5243 15.0875 16.8639 13.3417 17.6282C11.5958 18.3925 9.64071 18.5351 7.80241 18.0324C5.96411 17.5296 4.35372 16.4118 3.23981 14.8654C2.1259 13.319 1.57579 11.4375 1.68122 9.5346C1.78666 7.63171 2.54126 5.82247 3.81919 4.4086C5.09712 2.99474 6.82114 2.06171 8.70373 1.76511C10.5863 1.46851 12.5137 1.82627 14.1644 2.77873",
    stroke: "#00A63E",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49854 9.16513L9.99812 11.6647L18.3301 3.33276",
    stroke: "#00A63E",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8015_1966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9967,
    height: 19.9967,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolved);
export default __webpack_public_path__ + "static/media/solved.4609be8583440d739949e40dae2bba64.svg";
export { ForwardRef as ReactComponent };